export const NewEditTransferEnum = {
  NEW: '0',
  EDIT: '1',
};



// WEBPACK FOOTER //
// ./src/common/Constants/Enumeration/ManageTransferEnum.js